import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import MobileDrawer from "./MobileDrawer";
import CartCountBadge from "../shared/components/CartCountBadge";

const navItems = [
  {
    key: "home",
    label: "Home",
    to: "/",
    icon: "ph-house",
    isActive: (pathname) => pathname === "/",
  },
  {
    key: "shop",
    label: "Shop",
    to: "/collections",
    icon: "ph ph-magnifying-glass",
    isActive: (pathname) => pathname === "/collections",
  },
  {
    key: "cart",
    label: "Cart",
    to: "/cart",
    icon: "ph-handbag",
    isActive: (pathname) => pathname === "/cart",
  },
  {
    key: "store",
    label: "Wishlist",
    to: "/wishlist",
    icon: "ph ph-heart",
    isActive: (pathname) => pathname === "/wishlist",
  },
  {
    key: "profile",
    label: "Profile",
    to: "#",
    icon: "ph-user-circle",
    isActive: (pathname) => pathname === "#",
  },
];

const MobileBottomNav = () => {
  const { pathname, hash } = useLocation();

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeDrawerOverlay, setActiveDrawerOverlay] = useState("");
  const [isProfileDropdownOpen, setIsProfileDropdownOpen] = useState(false);

  return (
    <>
      <nav className="mobile-bottom-nav" aria-label="Mobile navigation">
        <ul className="mobile-bottom-nav__list">
          {navItems.map((item) => {
            const active = item.isActive(pathname, hash);

            return (
              <li className="mobile-bottom-nav__item" key={item.key}>
                <Link
                  to={item.to}
                  className={`mobile-bottom-nav__link ${active ? "is-active" : ""}`}
                >
                  <span
                    className="mobile-bottom-nav__icon-wrap"
                    onClick={() => {
                      if (item.key === "profile") {
                        setIsMobileMenuOpen(true);
                      }
                    }}
                  >
                    <i className={`ph ${item.icon}`} />
                    {item.key === "cart" && <CartCountBadge />}
                  </span>
                  <span className="mobile-bottom-nav__label">{item.label}</span>
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>
      <MobileDrawer
        isMobileMenuOpen={isMobileMenuOpen}
        setIsMobileMenuOpen={() => setIsMobileMenuOpen(false)}
        activeDrawerOverlay={activeDrawerOverlay}
        setActiveDrawerOverlay={setActiveDrawerOverlay}
        isProfileDropdownOpen={isProfileDropdownOpen}
        setIsProfileDropdownOpen={setIsProfileDropdownOpen}
      />
    </>
  );
};

export default MobileBottomNav;
